module.exports = __webpack_public_path__ + "static/media/charge-tip-qrcode.ac172eb3.png";